<template>
    <div>
        <div class="fw-userinfo">
            <img v-if="userInfo.sex==1" src="../../assets/empnan.png" class="u-img">
            <img v-if="userInfo.sex==0" src="../../assets/empnv.png"  class="u-img">
            <div class="u-info">
                <div style="display: flex;">
                    <span style="font-size: 15px;font-weight: bold">{{userInfo.nickName}}</span>
                    <span style="font-size: 11px;margin-left: 5px;font-weight: bold;line-height: 18px">{{userInfo.phone}}</span>
                </div>
                <div style="color:#B5B1B0;display: flex;">
                    <span style="font-size: 13px">{{userInfo.deptName}}( <span style="font-size: 11px">{{dgj.plabsName}}</span> )</span>
                </div>
            </div>
        </div>
        <div class="fw-ywbl">
            <div class="fw-ywbl-bt">
                <span style="line-height: 16px;">业务办理</span>
                <span style="font-size: 9px;">YE WU BAN LI</span>
            </div>
            <div class="fw-ywbl-nr">
                <div class="fyn-top">
                    <div class="fynt-l" @click="toChoose">
                        <span>开单</span>
                        <span class="yingwen">CASHIER</span>
                        <img src="../../assets/kd.png" class="kd-img">
                    </div>
                    <div class="fynt-r" @click="toKdMember">
                        <span>会员开单</span>
                        <span class="yingwen">MEMBER</span>
                        <img src="../../assets/hykd.png" class="kd-img">
                    </div>
                </div>
                <div class="fyn-bom" @click="toCustomer">
                    <img src="../../assets/khzx.png" class="khzx-img">
                    <span class="l">客户中心</span>
                    <span class="r">   CUSTOMER MANAGEMENT</span>
                    <span style="font-size: 18px;margin-left: 8px;line-height: 31px; color: #B5B1B0;">></span>
                </div>
            </div>
        </div>
        <div class="fw-home-menu">
<!--            <div class="fw-menu-item" @click="toChoose">-->
<!--                <img src="./../../assets/homemenu/fwkd.png">-->
<!--                <span>直接开单</span>-->
<!--            </div>-->
            <div class="fw-menu-item" @click="toWfp">
                <img src="./../../assets/homemenu/wfp.png">
                <span>未分配领取</span>
            </div>
<!--            <div class="fw-menu-item" style="margin-right: 5px">-->
<!--                <img src="./../../assets/homemenu/yykd.png">-->
<!--                <span>我的预约开单</span>-->
<!--            </div>-->
            <div class="fw-menu-item" @click="toTurnover">
                <img src="./../../assets/homemenu/lsdd.png">
                <span>流水对单</span>
            </div>
            <div class="fw-menu-item" @click="toTcs">
                <img src="./../../assets/homemenu/tcck.png">
                <span>套餐/次卡</span>
            </div>
<!--            <div class="fw-menu-item" style="margin-right: 5px" v-if="userType==2">-->
<!--                <img src="./../../assets/homemenu/spgl.png">-->
<!--                <span>秒杀分析</span>-->
<!--            </div>-->
        </div>
        <div class="fw-mb">
            <div class="mb-item">
                <div class="mb-item-bt">
                    <i class="el-icon-s-shop" style="font-size: 18px;margin-right: 12px"/>
                    <span style="font-size: 13px">{{currentDate}}</span>
                </div>
                <div class="mb-item-gls">
                    <div class="gls-sp">
                        <span class="t">已预约</span>
                        <span class="b">{{empService.yyyNum}}</span>
                    </div>
                    <div class="gls-sp">
                        <span class="t">未到店</span>
                        <span class="b">{{empService.wddNum}}</span>
                    </div>
                    <div class="gls-sp">
                        <span class="t">服务中</span>
                        <span class="b">{{empService.fwzNum}}</span>
                    </div>
                    <div class="gls-sp">
                        <span class="t">已服务</span>
                        <span class="b">{{empService.yfwNum}}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="fw-tabs">
            <div class="liebiao">
                <van-tabs v-model="active" class="selectTab">
                    <van-tab title="我的服务中列表">
                    </van-tab>
                </van-tabs>
                <span @click="shuaxin">刷新</span>
            </div>
            <div class="kdlist">
                <div v-for="item in kdList"
                     style="margin-bottom: 12px;background-color: #ffffff;border: #DDDDDD solid 1px">
                    <div class="kditem">
                            <span style="font-size: 13px">服务号: <span style="color:red;font-size: 13px">{{item.serviceName}}</span> <span
                                    style="margin-left: 28px;font-size: 8px;color: #2b94ff" @click="getFwRooms(item)">更改服务号</span></span>
                        <span style="font-size: 13px;height: 50px;line-height: 50px" v-if="item.memberName">{{item.memberName}}</span>
                        <span style="font-size: 13px;height: 50px;line-height: 50px"
                              v-if="!item.memberName">散客</span>
                        <span style="font-size: 11px;color: #888687;padding-bottom: 5px;border-bottom: #DDDDDD  solid 1px">{{item.createTime}}                         </span>
                        <div class="kditemname">
                            <span style="width: 40%">项目数</span>
                            <span style="color: #2b94ff">{{item.itemNum}}</span>
                        </div>
                        <div class="kditemname">
                            <span style="width: 40%">消费金额</span>
                            <span style="color: red">¥{{item.totalPrice}}</span>
                        </div>
                    </div>
                    <div class="btttn">
                        <span class="fwbtn" style="text-align:left">
                                    <i class="el-icon-news fwbtn-icon"/>
                                    <span>推项管理</span>
                                </span>
                        <span class="fwbtn" @click="toOrderInfo(item,'XQ')">
                                      <i class="el-icon-document fwbtn-icon"/>
                                   <span>服务详情</span>
                            </span>
                        <span class="fwbtn" style="text-align:right" @click="toAdd(item)">
                                      <i class="el-icon-edit-outline fwbtn-icon"/>
                                     <span>添加内容</span>
                            </span>
                        <span class="fwbtn" style="text-align:right" @click="toOrderInfo(item,'JS')">
                                      <i class="el-icon-edit-outline fwbtn-icon"/>
                                     <span>收银结算</span>
                            </span>
                    </div>
                </div>
                <span class="tishiyu">亲, 没有更多啦!</span>
            </div>
        </div>
        <van-popup v-model="mxShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <div style="padding: 15px;">
                <div class="fw-mx">
                    <span style="font-size: 15px">服务号: <span
                            style="color:red;font-size: 13px">{{kdInfo.serviceName}}</span></span>
                    <div class="fw-mx-nr">
                        <div style="display: flex;flex-direction: column">
                            <span style="height: 32px;font-size: 15px;line-height: 32px">{{kdInfo.memberName==null?'散客':kdInfo.memberName}}</span>
                            <span style="font-size: 12px;height: 20px;line-height: 20px">{{kdInfo.createTime}}</span>
                        </div>
                        <van-tabs class="kdtab" v-model="activeName">
                        <van-tab title="项目">
                            <div class="fw-mx-items">
                                <div class="fw-mx-item" v-for="(item,index) in kdInfo.itemStr">
                                    <div class="fwmxi-info">
                                        <span class="fm-name" @click="toEditItem(item,kdInfo.id,index)">{{item.itemName}}</span>
                                        <span class="fm-jg">¥{{item.price}}</span>
                                        <span class="fm-num">x1</span>
                                        <span class="fm-add" v-if="item.add==0"></span>
                                        <span class="fm-add1" v-if="item.add!=0">加 {{item.add}}</span>
                                    </div>
                                    <span class="mxemp" v-if="fName">{{fName}}: {{item.femp.empName}} </span>
                                    <span class="mxemp" v-if="sName">{{sName}}: {{item.semp.empName}}</span>
                                    <span class="mxemp" v-if="tName">{{tName}}: {{item.temp.empName}}</span>
                                </div>
                            </div>
                        </van-tab>
                        <van-tab title="商品">
                            <div class="fw-mx-items">
                                <div class="fw-mx-item" v-for="(item,index) in kdInfo.skuStr">
                                    <div class="fwmxi-info">
                                        <span class="fm-name" @click="toEditItem(item,kdInfo.id,index)">{{item.itemName}}</span>
                                        <span class="fm-jg">¥{{item.price}}</span>
                                        <span class="fm-num">x1</span>
                                        <span class="fm-add" v-if="item.add==0"></span>
                                        <span class="fm-add1" v-if="item.add!=0">加 {{item.add}}</span>
                                    </div>
                                    <span class="mxemp" v-for="emp in item.emps">{{emp.empName}} </span>
                                </div>
                            </div>
                        </van-tab>
                        <van-tab title="成品">
                            <div class="fw-mx-items">
                                <div class="fw-mx-item" v-for="(item,index) in kdInfo.specStr">
                                    <div class="fwmxi-info">
                                        <span class="fm-name" @click="toEditItem(item,kdInfo.id,index)">{{item.itemName}} <span style="margin-left: 5px">{{item.spec}}</span></span>
                                        <span class="fm-jg">¥{{item.price}}</span>
                                        <span class="fm-num">x1</span>
                                        <span class="fm-add" v-if="item.add==0"></span>
                                        <span class="fm-add1" v-if="item.add!=0">加 {{item.add}}</span>
                                    </div>
                                    <span class="mxemp" v-for="emp in item.emps">{{emp.empName}} </span>
                                </div>
                            </div>
                        </van-tab>
                    </van-tabs>
                    </div>
                </div>
            </div>
            <div class="jiesuan-btn" v-if="btnType=='JS'">
                <van-button type="default" class="jiesuanbtn" @click="toPay()">结算</van-button>
            </div>
        </van-popup>
        <van-popup v-model="fjShow" position="bottom" closeable lock-scroll overlay
                   :close-on-click-overlay="false"
                   style="height: 100%;">
                <span class="xmbt">
                    选择方式
                </span>
            <div class="fw-fjs">
                <div class="fw-fjs-item" v-for="item in rooms" @click="updateServiceNo(item)">
                    <span class="fjm">{{item.roomName}}</span>
                    <span class="fj-btn">点击开单</span>
                </div>
            </div>
        </van-popup>
        <van-popup v-model="empShow" position="bottom" closeable lock-scroll overlay>
            <div style="padding: 15px;border-bottom: #EEEEEE solid 1px">
                <div class="fwgr-item-info">
                    <span class="mc">{{item.itemName}}</span>
                    <span class="nr">内容：{{item.fwContent}}</span>
                    <span class="jg">¥{{item.price}}</span>
                    <div class="tiaozheng">
                        <span class="xiadanjiage">调整价格</span>
                        <el-input v-model="item.total" size="mini" placeholder="请输入价格" class="ki"></el-input>
                    </div>
                </div>
            </div>
            <div class="fw-gw-emps">
                <div class="emp-gw" v-if="fEmps.length>0">
                    <span class="gw">{{fName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" (emp,index) in fEmps">
                            <span class="empname" @click="setLEmp(emp,1)"
                                  @dblclick="setDEmp(emp,1)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(1)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(1)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="sEmps.length>0">
                    <span class="gw">{{sName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in sEmps">
                            <span class="empname" @click="setLEmp(emp,2)"
                                  @dblclick="setDEmp(emp,2)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(2)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(2)">点</span>
                        </div>
                    </div>
                </div>
                <div class="emp-gw" v-if="tEmps.length>0">
                    <span class="gw">{{tName}}</span>
                    <div class="fw-gw-emp">
                        <div class="emp" v-for=" emp in tEmps">
                            <span class="empname" @click="setLEmp(emp,3)"
                                  @dblclick="setDEmp(emp,3)">{{emp.nickName}}</span>
                            <span class="empgl" v-if="emp.status==1" @click="setUnchecked(3)">轮</span>
                            <span class="empgl" v-if="emp.status==2" @click="setUnchecked(3)">点</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="adddatabtn" @click="addData"> 确定</div>
        </van-popup>
        <van-popup v-model="mbShow" position="bottom" closeable lock-scroll overlay style="height: 100%;">
            <KdMemmber ref="kdmb" v-if="mbShow"  />
        </van-popup>
        <van-popup v-model="jsShow" position="bottom" lock-scroll overlay :close-on-click-overlay="false"
                   style="height: 77%;">
            <Pay v-if="jsShow" ref="pay" @gbPay="gbPay" :payItem="payItem"/>
        </van-popup>
    </div>
</template>

<script>
    import {formatDate, getCookie} from "../../utils/auth";
    import KdMemmber from "../common/kdmembers";
    import Pay from "../common/homepay";
    export default {
        components: {KdMemmber,Pay},
        data() {
            return {
                fwUser: {},
                deptId: '',
                token: '',
                emp: {},
                currentDate: '',
                active: 0,
                kdList: [],
                ygList: [],

                activeName:0,
                kdInfo: {},
                mxShow: false,
                fName: '',
                sName: '',
                tName: '',

                dept: {},
                empService: {},
                userType: '',
                btnType: '',

                memberId: '',
                mcId: '',
                totalAmount: 0,
                fjShow: false,
                orderId: '',
                rooms: [],

                empShow: false,
                item: {},
                upIndex: '',
                fEmps: [],
                sEmps: [],
                tEmps: [],

                userInfo:{},
                dgj: {},
                mbShow:false,

                jsShow: false,
                payItem:{},
            };
        },
        async created() {
            document.title = "数字智慧助手"
            this.fwUser = JSON.parse(getCookie("fwUser"))
            this.deptId = this.fwUser.deptId
            this.token = this.fwUser.token
            this.userType = this.fwUser.userType
            const today = new Date();
            var month = today.getMonth() + 1
            if (month < 10) {
                month = '0' + (today.getMonth() + 1).toString()
            }
            var day = today.getDate()
            if (day < 10) {
                day = '0' + today.getDate().toString()
            }
            this.currentDate = today.getFullYear() + '-' + (month) + '-' + day;
            this.getKdList()
            this.getMyWork()
            this.getFwEmps()
            this.getEmpInfo()
        },
        methods: {
            toKdMember(){
                this.mbShow=true
            },
            gbMember(){
                this.mbShow=false
            },

            shuaxin() {
                this.getKdList()
                this.getMyWork()
            },
            async getFwEmps() {
                let data = {
                    deptId: this.deptId,
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwEmps", data)
                this.fEmps = res.fEmps;
                this.sEmps = res.sEmps;
                this.tEmps = res.tEmps;
                // this.fName = res.fName;
                // this.sName = res.sName;
                // this.tName = res.tName;
            },
            async getEmpInfo() {
                let data = {
                    token: this.token
                }
                let res = await this.$get("/fw/getFwEmpInfo", data)
                console.log(res)
                this.userInfo = res.emp
                this.dgj = res.dgj
            },
            async getMyWork() {
                let data = {
                    token: this.token,
                }
                let res = await this.$get("/fw/getFwMyWork", data)
                this.dept = res.dept
                this.empService = res.empService
            },
            async getKdList() {
                let data = {
                    token: this.token,
                    deptId: this.deptId,
                    orderStatus: '3'
                }
                let res = await this.$get("/fw/getFwBillingList", data)
                this.kdList = res.orders
                this.kdList.forEach(item => {
                    item.itemStr = JSON.parse(item.itemStr)
                    item.skuStr = JSON.parse(item.skuStr)
                    item.specStr = JSON.parse(item.specStr)
                })
                this.fName = res.fName;
                this.sName = res.sName;
                this.tName = res.tName;
            },

            async toOrderInfo(order, btnType) {
                if (btnType == 'JS') {
                    //查询订单是否已经结算完成
                    let data = {
                        id: order.id,
                    }
                    let res = await this.$get("/fw/fwOrderComplete", data);
                    if (res.code == 200) {
                        if (order.memberId && order.mcId) {
                            this.memberId = order.memberId
                            this.mcId = order.mcId
                        }
                        this.totalAmount = order.totalPrice
                    } else {
                        this.$notify({type: 'danger', message: "订单已经完成,请刷新页面!"});
                        return;
                    }
                }
                this.btnType = btnType
                this.kdInfo = order
                this.mxShow = true
            },

            toPay(){
                let data={
                    orderId:this.kdInfo.id,
                }
                this.payItem= {
                    data: data,
                    totalStr: this.totalAmount.toString(),
                    memberId: this.memberId,
                    cardId: this.mcId,
                }
                this.jsShow = true
            },

            gbPay(item){
                if (item&&item=='save'){
                    this.getKdList()
                    this.getMyWork()
                    this.mxShow = false
                }
                this.jsShow = false
            },

            toAdd(item) {
                if (this.userType == 3) {
                    this.$router.push('/empTake/' + item.id)
                }
            },

            async getFwRooms(item) {
                this.orderId = item.id
                this.fjShow = true
                let data = {
                    deptId: this.deptId
                }
                let res = await this.$get("/fw/getFwRooms", data)
                this.rooms = res.list
            },
            async updateServiceNo(item) {
                let data = {
                    id: this.orderId,
                    serviceNo: item.roomNo,
                }
                let res = await this.$post("/fw/updateServiceNo", data)
                if (res.code == 200) {
                    this.getKdList()
                    this.fjShow = false
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            toEditItem(item, orderId, index) {
                let newItem = JSON.parse(JSON.stringify(item))
                newItem.total = newItem.price
                this.item = newItem
                this.orderId = orderId
                this.upIndex = index
                this.getFwEmps()
                this.empShow = true
            },
            async addData() {
                let fEmp = {}
                let sEmp = {}
                let tEmp = {}
                if (this.fEmps.length > 0) {
                    this.fEmps.forEach(item => {
                        if (item.status != 0) {
                            fEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 1,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.sEmps.length > 0) {
                    this.sEmps.forEach(item => {
                        if (item.status != 0) {
                            sEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 2,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                if (this.tEmps.length > 0) {
                    this.tEmps.forEach(item => {
                        if (item.status != 0) {
                            tEmp = {
                                empId: item.id,
                                empName: item.nickName,
                                station: 3,
                                gradeId: item.gradeId,
                                status: item.status
                            }
                        }
                    })
                }
                let item = this.item
                this.item.femp = fEmp
                this.item.semp = sEmp
                this.item.temp = tEmp
                let data = {
                    orderId: this.orderId,
                    upIndex: this.upIndex,
                    itemStr: JSON.stringify(this.item)
                }
                let res = await this.$post("/fw/updateOrderItem", data)
                if (res.code == 200) {
                    this.getKdList()
                    this.empShow = false
                    this.mxShow = false
                    this.$notify({type: 'success', message: res.message});
                } else {
                    this.$notify({type: 'danger', message: res.message});
                }
            },

            async setLEmp(item, type) {
                this.setUnchecked(type);
                item.status = 1
            },
            async setDEmp(item, type) {
                this.setUnchecked(type);
                item.status = 2
            },
            // 将选中的人状态更改为没选中
            setUnchecked(type) {
                if (type == 1) {
                    this.changeEmpFalse(this.fEmps);
                }
                if (type == 2) {
                    this.changeEmpFalse(this.sEmps);
                }
                if (type == 3) {
                    this.changeEmpFalse(this.tEmps)
                }
            },
            //更改状态
            changeEmpFalse(emps) {
                emps.forEach(item => {
                    if (item.status != 0) {
                        item.status = 0
                    }
                })
            },
            handleClick() {

            },
            toShiJian() {
                this.sjShow = true
            },
            queding(val) {
                let date = formatDate(val, 'yyyy-mm-dd')
                this.kdDate = date
                this.quxiao()
            },
            quxiao() {
                this.sjShow = false
            },
            toCustomer(){
                this.$router.push('/customer')
            },
            toChoose() {
                if (this.userType == 3) {
                    this.$router.push('/empChoose')
                }
            },
            toWfp() {
                this.$router.push('/wfp')
            },


            // toAddEmp() {
            //     this.$router.push('/addEmp')
            // },
            //流水对单
            toTurnover() {
                this.$router.push('/empTurnover?empId='+this.userInfo.id+'&station='+this.userInfo.station)
            },
            //套餐/次卡
            toTcs(){
                this.$router.push('/tcs')
            },

            addOrReplace(array, newObject) {
                const index = array.findIndex(obj => JSON.stringify(obj) === JSON.stringify(newObject));
                if (index !== -1) {
                    array[index] = newObject;
                } else {
                    array.unshift(newObject);
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .fw-userinfo{
        display: flex;
        flex-direction: row;
        padding: 12px;
        background-color: #FDF7F1;
    }
    .u-img{
        width: 50px;
        height: 50px;
    }
    .u-info{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 8px 8px 3px 8px
    }

    .fw-ywbl{
        padding: 12px 10px;
    }

    .fw-ywbl-bt{
        border-left: #00ACEF solid 4px;
        display: flex;
        flex-direction: column;
        padding-left: 5px;
        height: 25px;
    }

    .fw-ywbl-bt span{
        height: 15px;
        font-size: 12px;
    }

    .fw-ywbl-nr{
        padding-left: 10px;
        margin-top: 13px;
    }
    .fyn-top{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin: 13px 0 20px 0;
    }
    .fynt-l{
        height: 38px;
        width: 46%;
        font-size: 13px;
        text-align: left;
        background-color: #FDF7F1;
        padding: 5px 10px;

    }
    .fynt-l span{
        display: block;
    }
    .fynt-r{
        height: 38px;
        width: 46%;
        font-size: 13px;
        text-align: left;
        background-color: #F6F5FF;
        padding: 5px 10px;
    }
    .fynt-r span{
        display: block;
    }
    .yingwen{
        font-size: 11px;
        margin-top: 3px
    }
    .fyn-bom{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background-color: #F6F5FF;
        padding: 5px 10px;
    }
    .fyn-bom .l{
        width: 40%;
        font-size: 15px;
        line-height: 30px;
    }
    .fyn-bom .r{
        width: 60%;
        font-size: 12px;
        line-height: 30px;
        color: #B5B1B0;
        text-align: right;
    }
    .fw-home-menu {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        margin-top: 5px;
    }

    .fw-menu-item {
        flex: 1;
        box-sizing: border-box;
        font-size: 10px;
        text-align: center;
        margin: 10px 5px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: calc((100% - 40px) / 4); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc((100% - 40px) / 4);
        max-width: calc((100% - 40px) / 4);
        &:nth-child(4n + 4) {
            margin-right: 0;
        }
    }

    .fw-menu-item img {
        width: 29px;
        height: 29px;
    }

    .fw-menu-item span {
        margin-top: 10px;
    }

    .fw-mb {
        margin-top: 10px;
        padding: 18px 12px;
    }

    .mb-item {
        height: 120px;
        background-color: #F6F6F6;
        border-radius: 5px;
        padding: 15px;
    }

    .mb-item-bt {
        font-size: 13px;
        border-bottom: silver solid 1px;
        padding-bottom: 6px;
        display: flex;
        flex-direction: row;
        line-height: 18px;
    }

    .mb-item-gls {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin-top: 15px;
    }

    .fw-tabs {
        margin-bottom: 50px;
    }

    .gls-sp {
        width: 25%;
        display: flex;
        flex-direction: column;
        text-align: center;
        padding: 8px;
    }

    .gls-sp .t {
        font-size: 13px;
    }

    .gls-sp .b {
        font-size: 17px;
        color: red;
        padding-top: 16px;
    }

    .selectTab ::v-deep .van-tabs--line {
        height: 32px;
    }

    .selectTab ::v-deep .van-tabs__wrap {
        height: 32px;
    }

    ::v-deep .van-tabs__line {
        background-color: #2E3191;
        width: 98px;
    }

    .kdlist {
        display: flex;
        flex-direction: column;
        width: 95%;
        margin: auto;
        margin-top: 10px;
    }

    .kditem {
        display: flex;
        flex-direction: column;
        padding: 18px;
    }

    .kditemname {
        display: flex;
        flex-direction: row;
        font-size: 13px;
        margin-top: 30px;
    }

    .btttn {
        display: flex;
        flex-direction: row;
        height: 32px;
        justify-content: center;
        align-items: center;
        margin-top: 30px;
        padding: 0px 18px;
        margin-bottom: 8px;
    }

    .tishiyu {
        margin-top: 45px;
        display: inline-block;
        text-align: center;
        font-size: 13px;
        margin-bottom: 25px;
    }

    .fwbtn {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 33%;
        font-size: 12px;
        line-height: 32px;
        text-align: center;
    }

    .fwbtn-icon {
        font-size: 16px;
        line-height: 30px;
        margin-right: 3px;
    }

    .fw-mx-items {
        display: flex;
        flex-direction: column;
        border-top: #EEEEEE solid 1px;
        margin-top: 5px;
    }

    .mxemp {
        font-size: 10px;
        padding: 5px 0px;
        color: #999999;
    }

    .fw-mx-item {
        display: flex;
        flex-direction: column;
        background-color: #F7F7F7;
        margin-top: 5px;
        padding: 0 8px;
        padding-bottom: 3px;
    }

    .fwmxi-info {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: 32px;
    }

    .fm-name {
        font-size: 13px;
        width: 45%;
        color: #2b94ff;
        cursor: pointer;
    }

    .fm-jg {
        font-size: 11px;
        width: 25%;
    }

    .fm-num {
        width: 15%;
        font-size: 11px;
    }

    .fm-add {
        width: 50px;
        font-size: 12px;
        display: inline-block;
        text-align: right;
    }

    .fm-add1 {
        width: 50px;
        font-size: 12px;
        display: inline-block;
        text-align: right;
    }

    ::v-deep .van-radio__icon {
        -webkit-box-flex: 0;
        -webkit-flex: none;
        -ms-flex: none;
        flex: none;
        height: 1em;
        font-size: 13px;
        line-height: 1em;
        cursor: pointer;
        position: absolute;
        right: 30px;
    }

    .fw-fjs {
        display: flex;
        flex-flow: row wrap;
        padding: 0px 8px;
    }

    .fw-fjs-item {
        /*flex: 1;*/
        box-sizing: border-box;
        padding: 8px;
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        width: calc(100% / 3); // 我这里一行显示4个 所以是/4  一行显示几个就除以几
        min-width: calc(100% / 3);
        max-width: calc(100% / 3);

        &:nth-child(3n + 3) {
            margin-right: 0;
        }
    }

    .fjm {
        font-size: 15px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border-top: silver solid 1px;
        border-left: silver solid 1px;
        border-right: silver solid 1px;
    }

    .fj-btn {
        font-size: 13px;
        text-align: center;
        padding: 5px;
        border: silver solid 1px;
        background-color: #dddddd;
    }

    .liebiao {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 90%;
        margin: auto;
    }

    .liebiao span {
        font-size: 13px;
        color: #FFFFFF;
        border: #EEEEEE solid 1px;
        background-color: #2b94ff;
        padding: 3px 8px;
        margin-top: 6px;
        border-radius: 3px;
    }

    .fwgr-item-info {
        display: flex;
        flex-direction: column;
        padding-left: 5px;
    }

    .fwgr-item-info .mc {
        font-size: 13px;
        height: 20px;
        line-height: 20px;
    }

    .fwgr-item-info .nr {
        font-size: 11px;
        height: 20px;
        line-height: 20px;
        color: #A8A6A6;
    }

    .fwgr-item-info .jg {
        font-size: 13px;
        height: 20px;
        line-height: 20px;
        color: red;
    }

    .fw-btn {
        width: 100%;
        height: 50px;
        position: fixed;
        bottom: 0px;
        display: flex;
        flex-direction: row;
        align-items: center;
        color: #ffffff;
    }

    .tiaozheng {
        margin-top: 5px;
        height: 30px;
        line-height: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
    }

    .xiadanjiage {
        font-size: 11px;
        margin-right: 8px;
    }

    ::v-deep .el-input .el-input__inner {
        border-color: #ffffff;
        border-radius: 0px;
        border-bottom-color: #EEEEEE;
    }

    .ki {
        width: 60%;
    }




    .adddatabtn {
        width: 100%;
        height: 32px;
        font-size: 18px;
        background-color: #2b94ff;
        text-align: center;
        color: #ffffff;
        line-height: 32px;
    }
    .kd-img{
        float: right;
        width: 25px;
        height: 25px;
        position: relative;
        top:-25px;
        right: 8px;
    }

    .khzx-img{
        float: left;
        width: 30px;
        height: 30px;
        position: relative;
        left: 0px;
    }

</style>
